import { render } from "./EmployeeTerminationReasonModal.vue?vue&type=template&id=4e4559c2"
import script from "./EmployeeTerminationReasonModal.vue?vue&type=script&lang=js"
export * from "./EmployeeTerminationReasonModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__